// Available resolutions for video recording
export const resolutions = [
    {
        label: '1080p',
        value: { width: { exact: 1920 }, height: { exact: 1080 } },
        selected: true, // This resolution is selected by default
        supported: true, // Indicates whether the resolution is supported by the device
    },
    {
        label: '720p',
        value: { width: { exact: 1280 }, height: { exact: 720 } },
        supported: true,
    },
    {
        label: '480p',
        value: { width: { exact: 640 }, height: { exact: 480 } },
        supported: true,
    },
];

// Filtered resolutions specifically for virtual background
export const filteredResolutions = resolutions
    .filter((resolution) => resolution.label === '480p')
    .map((resolution) => ( { ...resolution, selected: true })); // Create a deep clone of each resolution object

// Internal resolutions for recorder's virtual background
export const internalResolutions = [
    {
        label: 'low',
    },
    {
        label: 'medium',
    },
    {
        label: 'high',
    },
    {
        label: 'full',
        selected: true, // 'full' resolution is selected by default
    },
];

// Initial state for the recorder component
export const RECORDER_STATE = {
    cameraRecorder: null,
    cameraStream: null,
    uploadPercentage: 0,
    webmMimeType: true,
    recorderParams: {},
    playVid: false,
    fontSize: null,
    cameraDevices: [],
    audioDevices: [],
    recordingLimit: '300',
    recordingTime: null,
    isVidAvailable: {},
    videoObj: {},
    isScreenRecording: false,
    screenStream: null,
    screenRecorder: null,
    backgrounds: [
        { label: 'Blur My Background', type: 'blur', selected: false },
        { label: 'Choose Virtual Background', type: 'virtual', selected: false },
    ],
};
